import React from 'react';

import { makeBtStyles, Theme } from '../Theme';
import { ThemeConfig } from '../themes';
import { CONTENT_WIDTH, MOBILE_CONTENT_WIDTH } from '../components/defaultStyleVars';
import { NavDrawerClasses } from '../components/NavDrawer';
import { makeOverridableStyles, MIN_TABLET_SIZE, StyleDef } from '../utils';
import SharedAppBar from '../components/SharedAppBar';


interface NavStyles {
  root?: StyleDef;
  toolbar?: StyleDef;
  paper?: StyleDef;
  menuLink?: StyleDef;
  link?: StyleDef;
  linkContainer?: StyleDef,
  socialMediaGrid?: StyleDef;
  socialMediaLink?: StyleDef;
  socialMediaLinkIcon?: StyleDef;
}
interface NavClasses {
  root?: string,
  toolbar?: string,
  paper?: string,
  menuLink?: string,
  link?: string,
  linkContainer?: string,
  socialMediaGrid?: string,
  socialMediaLink?: string,
  socialMediaLinkIcon?: string;
}

interface NavLogoStyles {
  textLogo?: StyleDef;
  root?: StyleDef;
  image?: StyleDef;
}
interface NavLogoClasses {
  textLogo?: string;
  root?: string;
  image?: string;
}

const useStyles = makeBtStyles( theme => ({
  desktopMenuClasses: {
    [theme.breakpoints.down(MIN_TABLET_SIZE)]: {
      display: 'none',
    }
  },
  draweMenuClasses: {
    [theme.breakpoints.up(MIN_TABLET_SIZE)]: {
      display: 'none',
    }
  }
}));


export default function NavBar({ navClasses={}, navDrawerClasses, logoClasses }:{
  navClasses: NavClasses,
  navDrawerClasses: NavDrawerClasses,
  logoClasses: NavLogoClasses
}) {
  const classes = useStyles();

  return (
    <SharedAppBar classes={classes} logoClasses={logoClasses} navClasses={navClasses} navDrawerClasses={navDrawerClasses} showSocialMedia={false}/>
  );
}

export function makeLogoStyles(styleOverrides: NavLogoStyles | ((theme:ThemeConfig)=>NavLogoStyles)) {
  return makeOverridableStyles(
    (theme: Theme) => ({
      textLogo: {
        textAlign: 'left',
        display: 'inline-block',
        marginLeft: 0,
        fontSize: 20,
        fontWeight: '500',
        lineHeight: '24px',
        color: '#222222',
        [theme.breakpoints.down(MIN_TABLET_SIZE)]: {
          textAlign: 'left'
        },
        [theme.breakpoints.up('xs')]: {
          textAlign: 'center'
        },
      },
      root: {
        textAlign: 'left',
        display: 'inline-block',
        verticalAlign: 'middle',
        marginLeft: 0,
        marginRight: '5px',
        [theme.breakpoints.down(MIN_TABLET_SIZE)]: {
          margin: '0 auto'
        },
      },
      image: {
        maxHeight: '45px',
        maxWidth: '150px'
      }
    }),
    styleOverrides,
    { name: 'LogoStyles' }
  );
}

export function makeNavStyles(styleOverrides: NavStyles | ((theme:ThemeConfig)=>NavStyles)) {
  return makeOverridableStyles(
    (theme: Theme) => ({
      root: {
        boxShadow: 'none',
        backgroundColor: 'white',
        border: '1px solid rgba(0, 0, 0, 0.12)',
      },
      toolbar: () => ({
        maxHeight: '64px',
        backgroundColor: 'white',
        width: MOBILE_CONTENT_WIDTH,
        padding: 0,
        margin: '0 auto',
        flexWrap: 'wrap',
        [theme.breakpoints.up(MIN_TABLET_SIZE)]: {
          width: `${CONTENT_WIDTH}px`,
          maxWidth: '98%'
        }
      }),
      paper: {},
      menuLink: {
        position: 'absolute',
        marginLeft: '-19px',
        '& svg': {
          transform: 'scale(1.6)',
          fill: theme.link.color
        }
      },
      link: {
        fontSize: '14px',
        verticalAlign: 'middle',
        marginLeft: '15px',
      },
      socialMediaGrid: {
        display: 'flex',
      },
      socialMediaLink: {
        padding: '0 5px',
        fontSize: '18px',
        marginLeft: 'auto',
        '&:last-child': {
          paddingRight: '0'
        },
      },
      socialMediaLinkIcon: {
        verticalAlign: 'middle',
      }
    }),
    styleOverrides,
    { name: 'NavStyles' }
  );
};